/**
 * cap-usage — how a cap's usage reads and colours (MD-1147), shared by the
 * Offers table cell and the Flow Optimizer chips: "used/limit" text, and a
 * tone of green under 80% of the limit, amber from 80%, red once reached.
 * For Media Devoted | Created By James Alexandrov
 */

export type CapUsageTone = "ok" | "warn" | "reached";

/** From this share of the limit the usage reads as a warning. */
export const CAP_WARN_AT = 0.8;

export function capUsageTone(
  cap: number,
  used: number | null,
  reached = false,
): CapUsageTone {
  if (reached || (used != null && cap > 0 && used >= cap)) return "reached";
  if (used != null && cap > 0 && used >= cap * CAP_WARN_AT) return "warn";
  return "ok";
}

/** "2/20"; an uncounted cap reads "0/20" (the cell's hover says it is not
 *  counted yet). */
export const capUsageText = (cap: number, used: number | null): string =>
  `${used ?? 0}/${cap}`;

/** Text colour per tone (table cells). */
export const CAP_TONE_TEXT: Record<CapUsageTone, string> = {
  ok: "text-success",
  warn: "text-warning",
  reached: "text-destructive",
};

/** Border + background + text per tone (chips). */
export const CAP_TONE_CHIP: Record<CapUsageTone, string> = {
  ok: "border-success/50 bg-success/10 text-success",
  warn: "border-warning/50 bg-warning/10 text-warning",
  reached: "border-destructive/50 bg-destructive/10 text-destructive",
};
